module.exports = __webpack_public_path__ + "img/22.88f3f874.jpg";